webpackJsonp([36829835628245],{

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ListItem = exports.LinkList = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin-right: 1em;\n"], ["\n  margin-right: 1em;\n"]);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var LinkList = _styledComponents2.default.ul(_templateObject);
	
	var ListItem = _styledComponents2.default.li(_templateObject2);
	
	exports.LinkList = LinkList;
	exports.ListItem = ListItem;

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0 1em;\n  max-width: 30em;\n  line-height: 1.6;\n"], ["\n  padding: 0 1em;\n  max-width: 30em;\n  line-height: 1.6;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin: 0;\n"], ["\n  margin: 0;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose([""], [""]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ExternalLink = __webpack_require__(57);
	
	var _ExternalLink2 = _interopRequireDefault(_ExternalLink);
	
	var _LinkList = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    Contents,
	    null,
	    _react2.default.createElement(
	      H1,
	      null,
	      "Impressum"
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      "Angaben gem\xE4\xDF \xA7 5 TMG:"
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      "Jurek Barth ",
	      _react2.default.createElement("br", null),
	      "Pelkovenstr. 70",
	      _react2.default.createElement("br", null),
	      "80992 M\xFCnchen ",
	      _react2.default.createElement("br", null),
	      "Deutschland"
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      "Haftung f\xFCr Inhalte ",
	      _react2.default.createElement("br", null),
	      "Die Inhalte unserer Seiten wurden mit gr\xF6\xDFter Sorgfalt erstellt. F\xFCr die Richtigkeit, Vollst\xE4ndigkeit und Aktualit\xE4t der Inhalte k\xF6nnen wir jedoch keine Gew\xE4hr \xFCbernehmen. Als Diensteanbieter sind wir gem\xE4\xDF \xA7 7 Abs.1 TMG f\xFCr eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach \xA7\xA7 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, \xFCbermittelte oder gespeicherte fremde Informationen zu \xFCberwachen oder nach Umst\xE4nden zu forschen, die auf eine rechtswidrige T\xE4tigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber\xFChrt. Eine diesbez\xFCgliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m\xF6glich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen."
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      "Haftung f\xFCr Links ",
	      _react2.default.createElement("br", null),
	      "Unser Angebot enth\xE4lt Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb k\xF6nnen wir f\xFCr diese fremden Inhalte auch keine Gew\xE4hr \xFCbernehmen. F\xFCr die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m\xF6gliche Rechtsverst\xF6\xDFe \xFCberpr\xFCft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen."
	    )
	  );
	};
	
	var Contents = _styledComponents2.default.div(_templateObject);
	
	var H1 = _styledComponents2.default.h1(_templateObject2);
	
	var Text = _styledComponents2.default.p(_templateObject3);
	
	exports.default = Contact;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-imprint-js-f23dac51da5ff89d0fa2.js